<template>
  <div class="news-card" @click="handleCardClick">
    <div class="img-wrap">
      <img :src="generateImageUrl(news.image) || dummyImage" alt="image" />
    </div>
    <div class="text-detail">
      <div class="news-title">{{ news.title }}</div>
      <div class="news-description" v-html="news.description"></div>
      <div class="extra-info">
        <div class="date-info">
          <a-icon type="clock-circle" />{{ news.createdAt | humanizeDate }}
        </div>
        <div class="tags-info">
          <a-icon type="folder-open" />{{
            news.category.map(cat => cat.categoryName).join(", ")
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DummyImage from "@/assets/images/dummy-profile-picture.png";

export default {
  name: "NewsCard",
  props: ["news"],
  mounted() {},
  data() {
    return {
      dummyImage: DummyImage
    };
  },
  methods: {
    handleCardClick() {
      this.$emit("click", this.news.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.news-card {
  background: #ffffff;
  padding: 30px;
  border-radius: 4px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  box-shadow: 0px 4px 10px 5px rgba(209, 209, 209, 0.6);
  transition: all 0.2s linear;
  .img-wrap {
    width: 40%;
  }
  .text-detail {
    width: 60%;
    padding: 0 0 0 30px;
    .news-title {
      font-size: 18px;
      line-height: 28px;
      font-weight: 500;
      color: #000;
    }
    .news-description {
      font-size: 14px;
      line-height: 26px;
      font-weight: 400;
      color: rgb(0, 0, 0);
      padding: 10px 0 20px;
      :not(:first-child) {
        display: none;
      }
      /deep/ p {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: rgb(0, 0, 0);
        font-size: 16px;
      }
    }
    .extra-info {
      padding-top: 20px;
      border-top: 1px solid #dddddd;
      display: flex;
      align-items: center;
      > div {
        margin-right: 15px;
        font-size: 14px;
        color: #7a8b91;
        font-weight: 500;
        .anticon {
          color: #d73228;
          margin-right: 8px;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  &:hover {
    box-shadow: 0px 0px 20px 10px rgba(209, 209, 209, 1);
  }
}

@media only screen and (max-width: 575px) {
  .news-card {
    flex-direction: column;
    .img-wrap {
      width: 100%;
    }
    .text-detail {
      width: 100%;
      padding-left: 0;
      padding-top: 20px;
      text-align: center;
      .extra-info {
        flex-direction: column;
        > div {
          margin: 0 0 15px 0;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
